import request from 'superagent';
import pathToRegexp from 'path-to-regexp';
import { reduce, clone, forIn, isArray, map, isObject, trim, snakeCase, camelCase } from 'lodash';
import MD5 from 'crypto-js/md5';
import { statusCode } from './status-code';
import { uuid } from './uuid';
import { globalConfig } from './global-config';
import { language } from './language';
import { getStore } from '../store';
import * as actions from '../actions';
/**
 * 请求方法
 */

var RequestMethods = ['get', 'post', 'put', 'patch', 'delete'];
/**
 * 封装实体的 API 接口调用相关操作
 */

var api = function () {
  function api() {}
  /**
   * 发送请求
   * @param config - 请求配置项
   */


  api.request = function (config) {
    var _a = config.method,
        method = _a === void 0 ? 'get' : _a,
        apiRoot = config.apiRoot,
        apiPath = config.apiPath,
        params = config.params,
        paramsFilter = config.paramsFilter,
        customHeaders = config.customHeaders;

    if (paramsFilter) {
      params = reduce(paramsFilter, function (result, name) {
        var value = params[name];

        if (value !== undefined && value !== null) {
          result[name] = value;
        }

        return result;
      }, {});
    } else {
      params = clone(params);
    }

    var path = this.formatPath(apiRoot, apiPath, params);
    params = this.formatObjectKeys(params, snakeCase);
    var req = globalConfig.get('features.withCredentials') ? request[method](path).withCredentials() : request[method](path);

    if (params) {
      switch (method) {
        case 'get':
          forIn(params, function (value, key) {
            if (isArray(value)) {
              params[key] = value.join(',');
            }
          });
          req = req.query(params);
          break;

        case 'delete':
          break;

        default:
          req = req.send(params);
          break;
      }
    }

    if (globalConfig.get('features.requestSign')) {
      var signParams = void 0;

      if (method === 'get') {
        signParams = params;
      } else if (method !== 'delete') {
        signParams = {
          body: params
        };
      }

      req.query(this.generateSign(signParams));
    } // 设置请求头


    req.set(this.generateHeaders(customHeaders));
    return req;
  };
  /**
   * 下载文件
   *
   * 响应头中需要提供 content-disposition
   *
   * @param data - 请求参数
   * @param config - 请求配置项
   */


  api.download = function (params, config) {
    var mixedConfig = Object.assign({}, config, {
      params: params,
      method: 'get'
    });
    return this.request(mixedConfig).responseType('blob').then(function (response) {
      var file = response.body;
      /filename="(.+)"$/.test(response.header['content-disposition']);
      var fileName = decodeURIComponent(RegExp.$1);
      var windowUrl = window['URL'] || window['webkitURL'];

      if (typeof navigator['msSaveBlob'] === 'function') {
        navigator.msSaveBlob(file, fileName);
      } else if (typeof windowUrl.createObjectURL === 'function') {
        var url = windowUrl.createObjectURL(file);
        var anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        windowUrl.revokeObjectURL(url);
      }
    }).catch(function (error) {
      /**
       * 异常情况 把结果从Blob类型转换为JSON
       */
      return new Promise(function (_resolve, reject) {
        var body = error.response.body;
        var reader = new FileReader();
        reader.readAsText(body);

        reader.onload = function () {
          if (reader.result) {
            error.response.body = JSON.parse(reader.result);
          }

          reject(error);
        };
      });
    }).catch(this.errorHandle);
  };
  /**
   * 上传文件
   *
   * @param params - 请求参数
   * @param config - 请求配置项
   */


  api.upload = function (params, config) {
    var _this = this;

    var _a = Object.assign({}, config),
        apiRoot = _a.apiRoot,
        apiPath = _a.apiPath,
        progressCallBack = _a.progressCallBack,
        fileName = _a.fileName,
        customHeaders = _a.customHeaders;

    var files = params.files,
        otherParams = params.otherParams;
    var path = this.formatPath(apiRoot, apiPath, otherParams);
    var req = request.post(path);
    var name = fileName ? fileName : 'files[]';
    req = req.attach(name, files);

    if (globalConfig.get('features.requestSign')) {
      req.query(this.generateSign({}));
    }

    req.set(this.generateHeaders(customHeaders));

    if (progressCallBack) {
      req.on('progress', function (e) {
        progressCallBack(e.percent);
      });
    }

    return req.then(function (_a) {
      var body = _a.body;
      return _this.formatObjectKeys(body, camelCase);
    }).catch(this.errorHandle);
  };
  /**
   * 请求失败处理
   *
   * @param error 请求信息
   */


  api.errorHandle = function (error) {
    error.statusCode = statusCode[error.status];

    if (error.status === statusCode.UNAUTHORIZED) {
      getStore().dispatch(actions.logoutAction());
    }

    return Promise.reject(error);
  };
  /**
   * 将对象中所有 key 转换为指定命名格式
   *
   * @param data 需要转换的对象
   * @param formatter 命名格式化方法
   */


  api.formatObjectKeys = function (data, formatter) {
    var _this = this;

    if (isArray(data)) {
      return map(data, function (item) {
        return _this.formatObjectKeys(item, formatter);
      });
    } else if (isObject(data)) {
      var result_1 = {};
      forIn(data, function (value, key) {
        result_1[formatter(key)] = _this.formatObjectKeys(value, formatter);
      });
      return result_1;
    } else {
      return data;
    }
  };
  /**
   * 格式化请求地址
   * @param rootPath - 请求根地址
   * @param relPath - 相对地址，支持声明路径参数，会通过 params 中的数据进行格式化处理
   * @param params - 参数对象，若其中有参数被注入到了 url 中，则会将该参数从对象中移除
   */


  api.formatPath = function (rootPath, relPath, params) {
    // 回避 ref 吐值导致的类型推断错误
    var relPathKeys = [];
    var relPathParams = {};
    rootPath = trim(rootPath ? rootPath : globalConfig.get('api.root'));
    relPath = trim(relPath);

    if (relPath === '/') {
      relPath = '';
    } // 将路径参数移到 relPathParams 中


    pathToRegexp(relPath, relPathKeys);
    relPathKeys.forEach(function (keyMatch) {
      var name = keyMatch.name;

      if (params) {
        relPathParams[name] = params[name];
        delete params[name];
      }
    }); // 格式化相对地址

    relPath = pathToRegexp.compile(relPath)(relPathParams);
    return rootPath + relPath;
  };
  /**
   * 生成请求签名信息
   * @param params - 参数对象
   */


  api.generateSign = function (params) {
    var _this = this;

    var timestamp = new Date().getTime();
    var apiKey = globalConfig.get('this.key');
    var mixedParams = Object.assign({}, params, {
      apiKey: apiKey,
      t: timestamp
    }, {
      token: globalConfig.get('this.token')
    });
    var md5List = map(mixedParams, function (value, key) {
      if (value === undefined || value === null || value === '') {
        return '';
      } else {
        return key + "=" + _this.ParamsSerialization(value);
      }
    });
    md5List.sort();
    return {
      apiKey: globalConfig.get('this.key') || '',
      t: timestamp,
      sign: MD5(md5List.join('')).toString()
    };
  };
  /**
   * 将 `参数对象` 序列化为字符串
   *
   * @param params - 参数对象
   */


  api.ParamsSerialization = function (params) {
    var _this = this;

    if (isArray(params)) {
      var array = map(params, function (item) {
        return _this.ParamsSerialization(item);
      });
      array.sort();
      return "[" + (array.length ? "{" + array.join('},{') + "}" : '') + "]";
    } else if (isObject(params)) {
      var result_2 = [];
      var keys = clone(Object.keys(params));
      keys.sort();
      forIn(keys, function (key) {
        var value = params[key];

        if (!isArray(value) && isObject(value)) {
          result_2.push(key + "={" + _this.ParamsSerialization(value) + "}");
        } else if (value !== undefined) {
          result_2.push(key + "=" + _this.ParamsSerialization(value));
        }
      });
      return result_2.join('&');
    } else {
      return params + '';
    }
  };
  /**
   * 生成请求头信息
   *
   * @param customHeaders 自定义请求头
   */


  api.generateHeaders = function (customHeaders) {
    var user = getStore().getState().user;
    var accessToken = user.accessToken;
    return Object.assign({}, {
      Authorization: "Bearer " + accessToken,
      'REQUEST-ID': uuid(),
      'Accept-Language': language.getCurrentLanguage().id
    }, customHeaders);
  };

  return api;
}();

export { api };
/**
 * 为所有请求方法注册快捷操作
 */

RequestMethods.forEach(function (method) {
  // WARN: 该方法内使用了指向 api 的 this, 因此不可使用箭头函数；
  api[method.toLowerCase()] = function (params, config) {
    var _this = this;

    var mixedConfig = Object.assign({}, config, {
      params: params,
      method: method
    });
    return this.request(mixedConfig).then(function (response) {
      return _this.formatObjectKeys(response.body, camelCase);
    }).catch(this.errorHandle);
  };
});